define('views/comments/reply',[
  "./comment",
  "./reply-form",
  "templates"
], function (CommentView, ReplyFormView, JST) {
  "use strict";

  return CommentView.extend({
    className: "reply",
    template: JST["app/assets/templates/comments/reply.html"],
    $editForm: $("#reply-form"),

    createFormView: function (mode) {
      return new ReplyFormView({
        collection: this.collection,
        model: this.model,
        el: $("#reply-forms").clone(),
        id: this.model.id,
        mode: mode
      });
    }
  });
});

